import React, { useState } from 'react';
import TextInput from '../../../../../components/inputs/TextInput';
import { Button, Col, Icon, Row, RSelect } from '../../../../../../components/Component';
import { Alert, Spinner } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import * as app_consts from "../../../../../../constants/react_app_consts";
import { getSelectedOption, removeWhitespaceAndCapitalize } from '../../../../../../utils/functionalUtils';
import { useSelector } from 'react-redux';
import { employee_dashboard_actions_helper } from '../../../../../../actions/actions_helper';
import { useEffect } from 'react';
import { fail_user_accounts_list, loading_user_accounts_list, reset_user_accounts_list, success_user_accounts_list } from '../../../../../../reducers/dashboard_reducers/user_accounts/user_accounts_list_Slice';
import { CREATE_DIRECT_DELIVERY_NOTE_TICKET_ACCESS_DENIED_MSG, CREATE_DIRECT_DELIVERY_NOTE_TICKET_ERR_MSG, CREATE_DIRECT_DELIVERY_NOTE_TICKET_SUCCESS_MSG, RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_ACCESS_DENIED_MSG, RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_ERR_MSG, RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_SUCCESS_MSG } from '../../../../../../constants/success_error_messages_consts';
import { CREATE_DIRECT_DELIVERY_NOTE_API, RETRIEVE_ACTIVE_USER_ACCOUNT_LIST } from '../../../../../../api/api_data';
import { messageToast } from '../../../../../../utils/Utils';
import { fail_create_delivery_note_ticket, loading_create_delivery_note_ticket, reset_create_delivery_note_ticket, success_create_delivery_note_ticket } from '../../../../../../reducers/dashboard_reducers/delivery_notes/create_delivery_note_ticket_Slice';

const initialState = { consigner_type: "", user_account_id: "", truck_driver_name: "", truck_licence_plate: "", trailer_one: "", trailer_two: "", contract_number: "", transporter_name: "", contact_name: "", contact_mobile: "", delivery_location: "" };

const AddDirectDeliveryNote = ({ page_data, openModal, successFunction }) => {
  // Variables
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [errorVal, setError] = useState("");
  const [formData, setFormData] = useState(initialState);
  const [consigner_loading, setConsignerLoading] = useState(true);
  const [current_consigner_list, setCurrentConsingerList] = useState([]);
  const [company_consigner_list, SetCompanyConsignerList] = useState([]);
  const [customer_consigner_list, SetCustomerConsignerList] = useState([]);
  const [consigner_list, setConsignerList] = useState([]);

  useEffect(() => {
    if (openModal && page_data)
    {
      fetchActiveConsigners();
      setFormData({ ...formData, transporter_name: page_data?.weigh_bridge_ticket?.transporter_name, truck_driver_name: page_data?.weigh_bridge_ticket?.truck_driver_name, truck_licence_plate: page_data?.weigh_bridge_ticket?.truck_licence_plate, trailer_one: page_data?.weigh_bridge_ticket?.trailer_one, trailer_two: page_data?.weigh_bridge_ticket?.trailer_two, delivery_location: page_data?.grn_schedule?.offload_point });
    }
  }, [openModal, page_data]);

  const fetchActiveConsigners = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_user_accounts_list,
        success_user_accounts_list,
        fail_user_accounts_list,
        RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_ERR_MSG,
        RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_SUCCESS_MSG,
        app_consts.GET,
        RETRIEVE_ACTIVE_USER_ACCOUNT_LIST,
        null,
        RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_ACCESS_DENIED_MSG
      )
    );
  };

  // Listen to State of user_account_list
  const user_accounts_list = useSelector((state) => state.user_accounts_list.user_accounts_list);

  useEffect(() => {
    if (user_accounts_list.status !== app_consts.IDLE)
    {
      if (user_accounts_list.status === app_consts.LOADING)
      {
        setConsignerLoading(true);
      } else
      {
        setConsignerLoading(false);
        if (user_accounts_list.status === app_consts.FAIL)
        {
          messageToast(user_accounts_list.message, app_consts.FAIL);
        } else if (user_accounts_list.status === app_consts.SUCCESS)
        {
          const remapped_company_data = user_accounts_list?.data?.company_accounts?.map((data) => {
            return {
              value: data.unique_identification_number,
              label: `${data.unique_identification_number} - ${data.company_name}`,
              phone_number: data?.phone_number,
              name: `${data.first_name} ${data.surname}`
            };
          });
          setConsignerList(user_accounts_list.data);

          const remapped_customer_data = user_accounts_list?.data?.customer_accounts?.map((data) => {
            return {
              value: data.unique_identification_number,
              label: `${data.unique_identification_number} - ${data.first_name} ${data.surname}`,
              phone_number: data?.phone_number,
              name: `${data.first_name} ${data.surname}`
            };
          });
          SetCustomerConsignerList(remapped_customer_data);
          SetCompanyConsignerList(remapped_company_data);
        }
        dispatch(reset_user_accounts_list());
      }
    }
  }, [user_accounts_list]);

  const handleConsignerSelection = (value) => {
    // Filter Accounts
    if (value === app_consts.COMPANY_CONSIGNER_STRING)
    {
      setCurrentConsingerList(company_consigner_list);
    }
    else if (value === app_consts.CUSTOMER_CONSIGNER_STRING)
    {
      setCurrentConsingerList(customer_consigner_list);
    }
    else
    {
      setCurrentConsingerList([]);
    }
    setFormData({ ...formData, consigner_type: value, user_account_id: "", contact_mobile: "", contact_name: "" });
  };


  // Handle Change
  const handleChange = (e) => {
    let change_value = e.target.value;
    if (e.target.name === "truck_licence_plate" || e.target.name === "trailer_one" || e.target.name === "trailer_two")
    {
      change_value = removeWhitespaceAndCapitalize(e.target.value);
    }
    setFormData({ ...formData, [e.target.name]: change_value });
  };

  const handleCreateDirectDeliveryNote = () => {
    setError("");
    const sent_data = { ...formData, goods_received_ref_number: page_data?.goods_received?.goods_received_ref_number };
    // Create Good Received Ticket
    dispatch(
      employee_dashboard_actions_helper(
        loading_create_delivery_note_ticket,
        success_create_delivery_note_ticket,
        fail_create_delivery_note_ticket,
        CREATE_DIRECT_DELIVERY_NOTE_TICKET_ERR_MSG,
        CREATE_DIRECT_DELIVERY_NOTE_TICKET_SUCCESS_MSG,
        app_consts.POST,
        CREATE_DIRECT_DELIVERY_NOTE_API,
        sent_data,
        CREATE_DIRECT_DELIVERY_NOTE_TICKET_ACCESS_DENIED_MSG
      )
    );
  };

  // Listen to Create Delivery Note Reducer
  const create_delivery_note_ticket = useSelector((state) => state.create_delivery_note_ticket.create_delivery_note_ticket);

  useEffect(() => {
    if (create_delivery_note_ticket.status !== app_consts.IDLE)
    {
      if (create_delivery_note_ticket.status === app_consts.LOADING)
      {
        setError("");
        setLoading(true);
      } else
      {
        setLoading(false);
        if (create_delivery_note_ticket.status === app_consts.FAIL)
        {
          setError(create_delivery_note_ticket.message);
          messageToast(create_delivery_note_ticket.message, app_consts.FAIL);
        } else if (create_delivery_note_ticket.status === app_consts.SUCCESS)
        {
          messageToast(CREATE_DIRECT_DELIVERY_NOTE_TICKET_SUCCESS_MSG, app_consts.SUCCESS);
          navigate(`/dashboard/delivery_notes/${create_delivery_note_ticket?.data?.delivery_note_ref_number}`);
        }
        dispatch(reset_create_delivery_note_ticket());
      }
    }
  }, [create_delivery_note_ticket]);

  const handle_user_account_select = (value) => {
    let contact_mobile = "";
    let contact_name = "";
    // Filter Accounts
    if (formData?.consigner_type === app_consts.COMPANY_CONSIGNER_STRING)
    {
      const filtered_data = company_consigner_list?.filter((data) => data?.value === value);
      contact_mobile = filtered_data[0]?.phone_number;
      contact_name = filtered_data[0]?.name;
    }
    else if (formData?.consigner_type === app_consts.CUSTOMER_CONSIGNER_STRING)
    {
      const filtered_data = customer_consigner_list?.filter((data) => data?.value === value);
      contact_mobile = filtered_data[0]?.phone_number;
      contact_name = filtered_data[0]?.name;
    }

    setFormData({ ...formData, user_account_id: value, contact_mobile: contact_mobile, contact_name: contact_name });
  };

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <Row className="g-4">
          <TextInput
            label="Contract Number"
            required
            type="text"
            id_val="contract_number"
            maxlength="100"
            value={formData.contract_number}
            handleChange={handleChange}
            colSize="4"
            name="contract_number"
          />
          <Col size={4}>
            <div className="form-group">
              <div className="form-label-group">
                <label className="form-label text-md" htmlFor="branch_location_id">
                  Client<span className='text-danger pr-2'>{` *`}</span>
                </label>
              </div>
              <div className="form-control-wrap align-items-center d-flex flex-row justify-between">
                <div className="w-100">
                  <RSelect
                    options={[{ value: app_consts.UAG_CONSIGNER_STRING, label: "UAG" }, { value: app_consts.COMPANY_CONSIGNER_STRING, label: "Company" }, { value: app_consts.CUSTOMER_CONSIGNER_STRING, label: "Individual Customer" }]}
                    className="w-100"
                    placeholder="Search"
                    id="consigner_type"
                    onChange={(e) => { handleConsignerSelection(e.value); }}
                    isDisabled={consigner_loading}
                  />
                </div>
              </div>
            </div>
          </Col>
          {
            (formData?.consigner_type === app_consts.COMPANY_CONSIGNER_STRING || formData?.consigner_type === app_consts.CUSTOMER_CONSIGNER_STRING) && (
              <>
                <Col size={4}>
                  <div className="form-group">
                    <div className='d-flex justify-between align-items-center'>
                      <label className="form-label text-md" htmlFor="user_account_id">
                        Client Details<span className='text-danger pr-2'>{` *`}</span>
                      </label>
                      {consigner_loading && (
                        <Spinner size="sm" />
                      )}
                    </div>
                    <div className="form-control-wrap align-items-center d-flex flex-row justify-between">
                      <div className="w-100">
                        <RSelect
                          options={current_consigner_list}
                          className="w-100"
                          placeholder="Search"
                          id="user_account_id"
                          onChange={(e) => handle_user_account_select(e.value)}
                          isDisabled={consigner_loading}
                          value={getSelectedOption(formData?.user_account_id, current_consigner_list)}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </>
            )
          }
          <TextInput
            colSize={4}
            label="Delivery Location"
            type="text"
            id_val="delivery_location"
            value={formData.delivery_location}
            handleChange={handleChange}
            name="delivery_location"
            required
          />
          <TextInput
            colSize={4}
            label="Contact Person Name"
            type="text"
            id_val="contact_name"
            value={formData.contact_name}
            handleChange={handleChange}
            name="contact_name"
            required
          />
          <TextInput
            colSize={4}
            label="Contact Person Mobile"
            type="text"
            id_val="contact_mobile"
            value={formData.contact_mobile}
            handleChange={handleChange}
            name="contact_mobile"
            required
          />
          <div className="form-label-group">
            <label className="form-label text-soft fs-18px">Truck Details</label>
          </div>
          <TextInput
            colSize={4}
            label="Transporter"
            required
            parentClassName={"mt-1"}
            type="text"
            id_val="transporter_name"
            value={formData.transporter_name}
            handleChange={handleChange}
            name="transporter_name"
          />
          <TextInput
            colSize={4}
            parentClassName={"mt-1"}
            label="Truck Driver"
            required
            type="text"
            id_val="truck_driver_name"
            value={formData.truck_driver_name}
            handleChange={handleChange}
            name="truck_driver_name"
          />
          <TextInput
            colSize={4}
            parentClassName={"mt-1"}
            label="Truck Horse Reg No."
            required
            type="text"
            id_val="truck_licence_plate"
            value={formData.truck_licence_plate}
            handleChange={handleChange}
            name="truck_licence_plate"
          />
          <TextInput
            colSize={4}
            label="Trailer Reg 1 Reg No. (Optional)"
            type="text"
            id_val="trailer_one"
            value={formData.trailer_one}
            handleChange={handleChange}
            name="trailer_one"
          />
          <TextInput
            colSize={4}
            label="Trailer Reg 2 Reg No.(Optional)"
            type="text"
            id_val="trailer_two"
            value={formData.trailer_two}
            handleChange={handleChange}
            name="trailer_two"
          />
          <div className="form-label-group">
            <label className="form-label text-soft fs-18px">Comments (Optional)</label>
          </div>
          <Col size="12" className="mt-0">
            <div className="form-group">
              <label className="form-label text-md" htmlFor="comments">
                Comments (Optional)
              </label>
              <div className="form-control-wrap">
                <textarea
                  className="no-resize form-control"
                  type="textarea"
                  id="default-textarea"
                  value={formData.comments}
                  onChange={handleChange}
                />
              </div>
            </div>
          </Col>
          {errorVal && (
            <div className="mb-3 w-100">
              <Alert color="danger" className="alert-icon">
                <Icon name="alert-circle" /> {errorVal}{" "}
              </Alert>
            </div>
          )}
          <Col xl="12">
            <div className="form-group">
              <div className="form-control-wrap-flex-wrap justify-end">
                <Button
                  onClick={handleCreateDirectDeliveryNote}
                  disabled={
                    loading
                      ? loading
                      : !(formData?.contact_mobile && formData?.contact_name && formData?.consigner_type && formData?.contract_number && formData.truck_driver_name && formData.truck_licence_plate && formData.transporter_name && (formData?.consigner_type === app_consts.UAG_CONSIGNER_STRING ? true : formData?.user_account_id))
                  }
                  color="primary"
                  size="md"
                >
                  {loading ? <Spinner size="sm" color="light" /> : "Create Direct Delivery Note"}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default AddDirectDeliveryNote;